import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { DataService } from "../../Services/DataSharingService";
import { Subscription } from "rxjs/Subscription";
import { ColorService } from "../../Services/ColorService";
import { FooterService } from "../../Services/FooterService";
import { Title } from "@angular/platform-browser";

@Component({
	selector: "app-footers",
	templateUrl: "./footers.component.html",
	styleUrls: ["./footers.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FootersComponent implements OnInit {
	@ViewChild("container", {
		read: ElementRef
	})
	container: ElementRef;
	private subscription: Subscription[] = [];
	public showCode = '';
	public data: string = "";
	footerSettings = {};
	footerColumnsArr: any = [];
	footerColumns: any = 1;
	widgetList = [];
	selectedColumnOneList = [];
	selectedColumnTwoList = [];
	selectedColumnThreeList = [];
	selectedColumnFourList = [];
	selectedColumnFiveList = [];
	selectedColumnSixList = [];
	dropdownSettings = {};
	columnOneSize: any = "uik-sm-6";
	columnTwoSize: any = "uik-sm-2";
	columnThreeSize: any = "uik-sm-2";
	columnFourSize: any = "uik-sm-2";
	columnFiveSize: any = "uik-sm-2";
	columnSixSize: any = "uik-sm-2";
	footer_background: any = "bg-gray";
	color_var: string = "light";
	alphaLevels: any = [];
	alpha_level: any = 1;
	bg_colors: any;
	columnSizes: any = [];

	constructor(
		private _dataService: DataService,
		private cdRef: ChangeDetectorRef,
		private _colorService: ColorService,
		private _footerService: FooterService,
		private _titleService: Title
	) {
		_titleService.setTitle('Footers');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
		this.subscription.push(
			this._colorService.bg_colors.subscribe(data => {
				this.bg_colors = data;
			})

		);
		this.subscription.push(_footerService.footerSettings.subscribe(data => {
			this.footerSettings = data;
		}))
		this.subscription.push(_footerService.columnSizes.subscribe(data => {
			this.columnSizes = data;
		}))
		this.subscription.push(_footerService.widgetList.subscribe(data => {
			this.widgetList = data;
		}))
		this.subscription.push(_footerService.footerColumnsArr.subscribe(data => {
			this.footerColumnsArr = data;
		}))
		this.subscription.push(_footerService.alphaLevels.subscribe(data => {
			this.alphaLevels = data;
		}))

		if (localStorage.footerSettings) {
			let footerSettings = JSON.parse(localStorage.footerSettings);
			this.loadSettings(footerSettings);
		}
	}

	ngOnInit() {
		this.subscription.push(
			this._dataService.GetCode().subscribe(code => {
				this.data = code;
				this.cdRef.detectChanges();
			})
		);

		if (!localStorage.footerSettings) {
			this.selectedColumnOneList = [
				{ item_class: "logo", item_text: "Company Logo" },
				{ item_class: "social_menu", item_text: "Social" },
				{ item_class: "subscribe_form", item_text: "Subscribe Form" },
				{ item_class: "payment_menu", item_text: "Payment Menu" }
			];

			this.selectedColumnTwoList = [
				{ item_class: "links1", item_text: "Links Menu 1" }
			];

			this.selectedColumnThreeList = [
				{ item_class: "links2", item_text: "Links Menu 2" }
			];

			this.selectedColumnFourList = [
				{ item_class: "links3", item_text: "Links Menu 3" }
			];
			this.selectedColumnFiveList = [
				{ item_class: "links3", tem_text: "Links Menu 3" }
			];
			this.selectedColumnSixList = [
				{ item_class: "links3", item_text: "Links Menu 3" }
			];
		}
		this.dropdownSettings = {
			singleSelection: false,
			idField: "item_class",
			textField: "item_text",
			unSelectAllText: "UnSelect All",
			itemsShowLimit: 4,
			enableCheckAll: false,
			allowSearchFilter: false
		};

		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'footers') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('footers');
		}
	}

	SetFooterColumns(value: string) {
		if (value) {
			this.footerColumns = value;
		}
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	SetColumnOneSize(value: string) {
		this.columnOneSize = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetColumnTwoSize(value: string) {
		this.columnTwoSize = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetColumnThreeSize(value: string) {
		this.columnThreeSize = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetColumnFourSize(value: string) {
		this.columnFourSize = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetColumnFiveSize(value: string) {
		this.columnFiveSize = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetColumnSixSize(value: string) {
		this.columnSixSize = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	onItemSelect(item: any) {
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	onItemDeSelect(item: any) {
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetFooterColumnsColor(value: any) {
		this.footer_background = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetBackgroundVariation(value: any) {
		this.color_var = value;
		this.alpha_level = 0;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	SetAlphaLevel(value: any) {
		this.alpha_level = value;
		this.cdRef.detectChanges();
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	Save() {
		let footerSettings = {
			footerColumns: this.footerColumns,
			widgetList: this.widgetList,
			selectedColumnOneList: this.selectedColumnOneList,
			selectedColumnTwoList: this.selectedColumnTwoList,
			selectedColumnThreeList: this.selectedColumnThreeList,
			selectedColumnFourList: this.selectedColumnFourList,
			selectedColumnFiveList: this.selectedColumnFiveList,
			selectedColumnSixList: this.selectedColumnSixList,
			dropdownSettings: this.dropdownSettings,
			columnOneSize: this.columnOneSize,
			columnTwoSize: this.columnTwoSize,
			columnThreeSize: this.columnThreeSize,
			columnFourSize: this.columnFourSize,
			columnFiveSize: this.columnFiveSize,
			columnSixSize: this.columnSixSize,
			footer_background: this.footer_background,
			color_var: this.color_var,
			alpha_level: this.alpha_level
		};
		localStorage.setItem("footerSettings", JSON.stringify(footerSettings));
		this._footerService.setFooterSettings(footerSettings);
	}

	loadSettings(footerSettings) {
		this.footerColumns = footerSettings.footerColumns;
		this.widgetList = footerSettings.widgetList;
		this.selectedColumnOneList = footerSettings.selectedColumnOneList;
		this.selectedColumnTwoList = footerSettings.selectedColumnTwoList;
		this.selectedColumnThreeList = footerSettings.selectedColumnThreeList;
		this.selectedColumnFourList = footerSettings.selectedColumnFourList;
		this.selectedColumnFiveList = footerSettings.selectedColumnFiveList;
		this.selectedColumnSixList = footerSettings.selectedColumnSixList;
		this.dropdownSettings = footerSettings.dropdownSettings;
		this.columnOneSize = footerSettings.columnOneSize;
		this.columnTwoSize = footerSettings.columnTwoSize;
		this.columnThreeSize = footerSettings.columnThreeSize;
		this.columnFourSize = footerSettings.columnFourSize;
		this.columnFiveSize = footerSettings.columnFiveSize;
		this.columnSixSize = footerSettings.columnSixSize;
		this.footer_background = footerSettings.footer_background;
		this.color_var = footerSettings.color_var;
		this.alpha_level = footerSettings.alpha_level;
	}
	loadDefaults() {
		let footerSettings = this._footerService.loadDefaults();
		this.footerColumns = footerSettings.footerColumns;
		this.widgetList = footerSettings.widgetList;
		this.selectedColumnOneList = footerSettings.selectedColumnOneList;
		this.selectedColumnTwoList = footerSettings.selectedColumnTwoList;
		this.selectedColumnThreeList = footerSettings.selectedColumnThreeList;
		this.selectedColumnFourList = footerSettings.selectedColumnFourList;
		this.selectedColumnFiveList = footerSettings.selectedColumnFiveList;
		this.selectedColumnSixList = footerSettings.selectedColumnSixList;
		this.dropdownSettings = footerSettings.dropdownSettings;
		this.columnOneSize = footerSettings.columnOneSize;
		this.columnTwoSize = footerSettings.columnTwoSize;
		this.columnThreeSize = footerSettings.columnThreeSize;
		this.columnFourSize = footerSettings.columnFourSize;
		this.columnFiveSize = footerSettings.columnFiveSize;
		this.columnSixSize = footerSettings.columnSixSize;
		this.footer_background = footerSettings.footer_background;
		this.color_var = footerSettings.color_var;
		this.alpha_level = footerSettings.alpha_level;
	}
}



// WEBPACK FOOTER //
// ./src/app/footers/footers.component.ts